import { useState, useContext, useEffect, useCallback } from "react";
import { notification } from "antd";
import { AppContext } from "~/src/libs/context";
import { promoHandler } from "~/src/libs/utils/promoHandler";
import { useRouter } from "next/router";
import { getCookie } from "src/server/utils/commonUtils";
import useCompareProducts from "~/src/utilities/hooks/useCompareProducts";
import { getText } from "~/src/libs/resources";
import { AppliedFilter,ProductProps } from "../types";
import {
  useSetProductQuantity,
  useAddItemToPallet,
  useBuildMixedPallet,
  useChangeName,
  useChangePalletCustomerName,
  useGetMixedPalletProducts,
  useGetPalletById,
  useSetPalletProductQuantity,
  usePalletById,
} from "~/src/services/pallet/hooks";
import { isNil } from "lodash";
import {
  AddItemToCartPayload,
  AddItemToPalletPayload,
} from "~/src/types/pallet";
import { useDispatch } from "react-redux";
import {
  setIsLoaded,
  setLoading,
  setPalletItems,
  setPalletLoadedProgress,
  setPalletName,
  setVendorProducts,
} from "~/src/libs/utils/mixedPallet";
import Selector from "~/src/modules/MixedPallet/selector";
import { useTypedSelector } from "~/src/libs/utils/useTypedSelector";
import { MixedPalletContext } from "~/src/libs/context/mixedPallet";
import { setProductListInfo } from "~/src/libs/utils/products";
import useClient from "~/src/server/utils/client";
import axios from "axios";

export const useCardLogic = ({
  customerStatus,
  isGuestUser,
  id,
  titleOfList,
  product,
}: ProductProps) => {
  const router = useRouter();
  const [favClick, setFavClick] = useState(false);
  const dispatch = useDispatch();
  const { sortByVal, searchVal, setPalletId, palletId } =
    useContext<any>(MixedPalletContext);
  const {
    palletName,
    loading,
    vendorId,
    vendorName,
    offset,
    appliedPalletFilters,
    palletItems,
    vendorProducts
  } = useTypedSelector(Selector.getMixedPallet);

  const [showShoppingListDialog, setShowToShoppingListDialog] =
    useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>();
  const [itemShoppingLists, setItemShoppingLists] = useState<any>();
  const [inCart, setInCart] = useState<any>(false);
  const {
    customerStatus: contextCustomerStatus,
    guestUser: contextGuestUser,
    defaultPostZip,
    cart,getCartCount
  } = useContext<any>(AppContext);
  const { compareProductHandler } = useCompareProducts();
  const [addToCartStatus, setAddToCartStatus] = useState(false);
  const [isWishlist, setIsWishlist] = useState<boolean>(false || product?.is_wished);
  const [validCustomerStatus, setValidCustomerStatus] = useState<any>();
  const [validGuestUser, setValidGuestUser] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const client = useClient({});
  const {
    apiCall: addItemToPalletApi,
    response: addItemToPalletResponse,
    error: addItemToPalletError,
    isLoading: addItemToPalletLoading,
  } = useAddItemToPallet();

  const {
    apiCall: changePalletName,
    response: changePalletNameResponse,
    error: changePalletNameError,
    isLoading: changePalletNameLoading,
  } = useChangePalletCustomerName();

  const { apiCall: changeNameApi, response: changeNameResponse } =
    useChangeName();

  const {
    apiCall: getMixedPalletProducts,
    response: getMixedPalletProductsResponse,
    error: getMixedPalletProductsError,
    isLoading: getMixedPalletProductsLoading,
  } = useGetMixedPalletProducts();

  const {
    apiCall: setPalletProductQuantity,
    response: setPalletProductQuantityResponse,
    error: setPalletProductQuantityError,
    isLoading: setPalletProductQuantityLoading,
  } = useSetPalletProductQuantity();

  const {
    apiCall: palletById,
    response: palletByIdResponse,
    error: palletByIdError,
    isLoading: palletByIdLoading,
  } = usePalletById();

  const {
    apiCall: getPalletById,
    response: getPalletByIdResponse,
    error: getPalletByIdError,
    isLoading: getPalletByIdLoading,
  } = useGetPalletById();

  const {
    apiCall: buildMixedPalletApi,
    response: buildMixedPalletResponse,
    error: buildMixedPalletError,
    isLoading: buildMixedPalletLoading,
  } = useBuildMixedPallet();

  const {
    apiCall: setQuantityApi,
    response: setQuantityResponse,
    error: setQuantityError,
    isLoading: addItemToCartLoading,
  } = useSetProductQuantity();

  useEffect(() => {
    const isLoading =
      addItemToPalletLoading ||
      changePalletNameLoading ||
      addItemToCartLoading ||
      buildMixedPalletLoading ||
      getMixedPalletProductsLoading ||
      getPalletByIdLoading ||
      setPalletProductQuantityLoading ||
      false;

    if (!setLoading || isLoading == loading) return;
    dispatch(setLoading(isLoading));
  }, [
    addItemToPalletLoading,
    changePalletNameLoading,
    getMixedPalletProductsLoading,
    setPalletProductQuantityLoading,
    getPalletByIdLoading,
    addItemToCartLoading,
    buildMixedPalletLoading,
  ]);

  const showModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  useEffect(() => {
    if (!customerStatus && customerStatus === undefined) {
      setValidCustomerStatus(contextCustomerStatus);
    } else {
      setValidCustomerStatus(customerStatus);
    }
  }, [customerStatus]);

  useEffect(() => {
    if (!isGuestUser && isGuestUser === undefined) {
      setValidGuestUser(contextGuestUser);
    } else {
      setValidGuestUser(isGuestUser);
    }
  }, [isGuestUser]);

  const isCustomerDataCompleted =
    !validGuestUser &&
    validCustomerStatus?.profile_completed === true &&
    validCustomerStatus?.email_verified === true;


  useEffect(() => {
    if (!getMixedPalletProductsResponse?.data) return;
    const { results, filters } = getMixedPalletProductsResponse.data;
    dispatch(setVendorProducts(results));
    notification.success({
      message: getText().PDP.messages.productAddedToPallet,
      duration: 3,
    });
  }, [getMixedPalletProductsResponse]);

  const getMixedPallet = useCallback(
    (initialParams = {}) => {
      const params = { ...initialParams } as Record<string, any>;
      if (defaultPostZip) params.post_zip = defaultPostZip;
      const searchQuery = router.query.search;
      if (searchVal && searchQuery) params.search = searchVal;
      params.limit = offset + 6;
      params.offset = offset > 0 ? 0 : offset;
      if (appliedPalletFilters && appliedPalletFilters.length > 0) {
        const filters = [] as any;
        appliedPalletFilters?.forEach((item: any) => {
          const filter = filters.find(
            ({ name }: any) => name === item?.filter?.name
          ) ?? {
            name: item?.filter?.name,
            ids: [],
          };
          filter.ids.push(item?.filter?.id);
        });

        delete router.query?.category;
        delete router.query?.pack;

        filters.forEach(({ ids, name }: AppliedFilter) => {
          params[name] = ids?.toString();
          router.query[name] = ids;
        });

        router.push(router, undefined, { shallow: true });
      }
      getMixedPalletProducts({ params, client });
    },
    [appliedPalletFilters, defaultPostZip, offset, searchVal, router]
  );

  useEffect(() => {
    if (!changePalletNameResponse?.data) return;
    dispatch(setPalletName(changePalletNameResponse.data.name));
  }, [changePalletNameResponse]);

  useEffect(() => {
    if (!palletByIdResponse?.data) return;
    dispatch(setPalletName(palletByIdResponse.data.name));
    const initialParams = {
      status: true,
      limit: 6,
      vendor: vendorId,
      ordering: sortByVal,
      pallet: id,
    };
    getMixedPallet(initialParams);
  }, [palletByIdResponse]);
  useEffect(() => {
    if (!changeNameResponse?.data) return;
    const { data } = buildMixedPalletResponse ?? { data: {} };
    const { products, id } = data;
    router.push(
      `/mixed-pallet-vendor?ordering=delivered_case_price&pallet=${id}&vendor=${products?.[0]?.product?.vendor_id}`
    );
  }, [changeNameResponse]);

  useEffect(() => {
    if (!setPalletProductQuantityResponse) return;
    
    console.log('🎯 [useCardLogic] setPalletProductQuantityResponse received:', setPalletProductQuantityResponse.data);
    
    // 🚀 OPTIMIZATION: Check if we have enhanced response with optimization data
    const responseData = setPalletProductQuantityResponse.data;
    if (responseData && responseData.pallet_load_percents !== undefined && responseData.is_loaded !== undefined) {
      console.log('🚀 [useCardLogic] Using enhanced API response - skipping GET call!');
      
      // Update Redux state directly from enhanced response
      dispatch(setPalletLoadedProgress(responseData.pallet_load_percents));
      dispatch(setIsLoaded(responseData.is_loaded));
      
      // If products array is included, update it
      if (responseData.products) {
        dispatch(setPalletItems(responseData.products));
      } else {
        // 🚀 OPTIMIZATION: Enhanced response without products array - update state manually
        console.log('🔧 [useCardLogic] Enhanced response without products array, updating state manually...');
        
        // Get current pallet items from Redux state
        const currentPalletItems = [...palletItems];
        
        // Find the product info from vendorProducts to get complete product data
        const productInfo = vendorProducts?.find((vendorProduct: any) => 
          vendorProduct?.product?.id === product?.id
        );
        
        if (productInfo) {
          // Create the new product entry
          const newProduct = {
            product: productInfo.product,
            case_quantity: productInfo.product.case_quantity || productInfo.product.default_case_quantity || productInfo.ti,
            is_valid: true,
            is_available: true
          };
          
          // Check if product already exists, if not add it
          const existingProductIndex = currentPalletItems.findIndex(
            (palletItem: any) => palletItem.product?.id === product?.id
          );
          
          if (existingProductIndex >= 0) {
            // Update existing product quantity
            currentPalletItems[existingProductIndex].case_quantity = newProduct.case_quantity;
          } else {
            // Add new product to pallet
            currentPalletItems.push(newProduct);
          }
          
          // Update Redux state without API call
          dispatch(setPalletItems(currentPalletItems as any));
          console.log('✅ [useCardLogic] State updated manually - no GET call needed!');
        } else {
          console.warn('[useCardLogic] Product not found in vendorProducts, state not updated');
        }
      }
      
      // If name is included, update it too
      if (responseData.name) {
        dispatch(setPalletName(responseData.name));
      }
      
      // Show success notification for optimized path
      notification.success({
        message: getText().PDP.messages.productAddedToPallet,
        duration: 3,
      });
      
      // Skip the redundant GET call - optimization complete!
      return;
    }
    
    // 📞 FALLBACK: Legacy response format - make GET call
    console.log('📞 [useCardLogic] Legacy response format - making GET call');
    const params = {
      ...(defaultPostZip ? { post_zip: defaultPostZip } : {}),
    };
    getPalletById({ palletId, params, client });
  }, [setPalletProductQuantityResponse]);

  useEffect(() => {
    if (!palletByIdError) return;
    setLoading(false);
  }, [palletByIdError]);

  // 🚀 REMOVED: Old service hook response handler - now using direct axios calls like drag & drop
  /*
  useEffect(() => {
    if (isNil(addItemToPalletResponse?.data)) return;

    console.log('🎯 [useCardLogic] addItemToPalletResponse received (new pallet):', addItemToPalletResponse.data);

    const { data } = addItemToPalletResponse ?? { data: {} };
    const { id, products, pallet_load_percents, is_loaded } = data;
    dispatch(setPalletItems(products));
    dispatch(setPalletLoadedProgress(pallet_load_percents));
    setPalletId(`${id}`);
    dispatch(setIsLoaded(is_loaded));
    router.query.pallet = id;
    router.push(router, undefined, { shallow: true });

    if (!palletName) {
      changePalletName({
        id,
        payload: {
          data: {
            name: `${vendorName} Mixed Pallet`,
          },
          headers: { sessionId: getCookie("sessionid") },
        },
        client,
      });
    }
    
    // 📞 SCENARIO 1: New Pallet Creation - Mayur's requirement to call both APIs
    console.log('📞 [useCardLogic] New pallet created - calling GET API as per requirements');
    const params = {
      ...(defaultPostZip ? { post_zip: defaultPostZip } : {}),
    };
    palletById({ palletId: id, params, client });
  }, [addItemToPalletResponse]);
  */

  useEffect(() => {
    if (!getPalletByIdResponse?.data) return;
    const { products, pallet_load_percents, is_loaded } =
      getPalletByIdResponse.data;
    dispatch(setPalletItems(products));
    dispatch(setPalletLoadedProgress(pallet_load_percents));
    dispatch(setIsLoaded(is_loaded));
  }, [getPalletByIdResponse]);

  useEffect(() => {
    if (isNil(buildMixedPalletResponse?.data)) return;
    const { data } = buildMixedPalletResponse ?? { data: {} };
    const { id } = data;
    router.query.pallet = id;
    notification.success({
      message: getText().PDP.messages.productAddedToPallet,
      duration: 8,
    });
    changeNameApi({
      id,
      payload: {
        data: {
          name: `${vendorName} Mixed Pallet`,
        },
        headers: { sessionId: getCookie("sessionid") },
      },
      client,
    });
  }, [buildMixedPalletResponse]);

  useEffect(() => {
    if (isNil(buildMixedPalletError)) return;
    console.error(buildMixedPalletError);
  }, [buildMixedPalletError]);

  useEffect(() => {
    if (!setQuantityResponse) return;
    const { data } = setQuantityResponse;
    setAddToCartStatus(false);
    setInCart(true);
    addToCartHandler(product, "add_to_cart");
    notification.success({
      message: getText().PDP.messages.ProductAddedSuccessfully,
      duration: 2,
    });
    const params = defaultPostZip ? { post_zip: defaultPostZip } : {};
    getCartCount()
    localStorage.setItem("CartID", data?.cartId);
  }, [setQuantityResponse]);

  useEffect(() => {
    if (isNil(setQuantityError)) return;
    setAddToCartStatus(false);
    notification.error({
      message: getText()?.General?.Messages?.SomethingWrongTryAgain,
      duration: 2,
    });
    console.error(setQuantityError);
  }, [setQuantityError]);

  // 🚨 NEW: Add error handling for setPalletProductQuantityError (Add to Pallet button)
  useEffect(() => {
    if (isNil(setPalletProductQuantityError)) return;
    setAddToCartStatus(false);
    
    console.error('🔢 [useCardLogic] setPalletProductQuantityError:', setPalletProductQuantityError);
    
    // 🚨 Handle pallet capacity error (400 status)
    if (setPalletProductQuantityError?.response?.status === 400) {
      let errorMessage = getText().General.Messages.SomethingWrongTryAgain;
      
      // Check if response data is an array (backend format)
      if (Array.isArray(setPalletProductQuantityError.response?.data) && setPalletProductQuantityError.response.data.length > 0) {
        errorMessage = setPalletProductQuantityError.response.data[0];
      } 
      // Check if response data has message property
      else if ((setPalletProductQuantityError.response?.data as any)?.message) {
        errorMessage = (setPalletProductQuantityError.response.data as any).message;
      }
      
      notification.error({
        message: errorMessage,
        duration: 4,
      });
    } else {
      notification.error({
        message: getText()?.General?.Messages?.SomethingWrongTryAgain,
        duration: 4,
      });
    }
  }, [setPalletProductQuantityError]);

  // 🚨 NEW: Add error handling for addItemToPalletError (new pallet creation)
  useEffect(() => {
    if (isNil(addItemToPalletError)) return;
    setAddToCartStatus(false);
    
    console.error('🔢 [useCardLogic] addItemToPalletError:', addItemToPalletError);
    
    // 🚨 Handle pallet capacity error (400 status)
    if (addItemToPalletError?.response?.status === 400) {
      let errorMessage = getText().General.Messages.SomethingWrongTryAgain;
      
      // Check if response data is an array (backend format)
      if (Array.isArray(addItemToPalletError.response?.data) && addItemToPalletError.response.data.length > 0) {
        errorMessage = addItemToPalletError.response.data[0];
      } 
      // Check if response data has message property
      else if ((addItemToPalletError.response?.data as any)?.message) {
        errorMessage = (addItemToPalletError.response.data as any).message;
      }
      
      notification.error({
        message: errorMessage,
        duration: 4,
      });
    } else {
      notification.error({
        message: getText()?.General?.Messages?.SomethingWrongTryAgain,
        duration: 4,
      });
    }
  }, [addItemToPalletError]);

  const addItemToPallet = useCallback(async () => {
    if (isNil(palletId)) {
      // 🚀 EXACT DRAG & DROP LOGIC: Use same API calls as drag & drop
      dispatch(setLoading(true));
      
      let _url = `/api/ERP/customer/mixedPallet`;
      if (defaultPostZip) {
        _url += `?post_zip=${defaultPostZip}`;
      }
      
      console.log('🎯 [BUTTON] Creating pallet with EXACT drag & drop API');
      
      await axios.post(_url, {
        data: { product: product?.id, case_quantity: null },
        headers: { sessionId: getCookie("sessionid") },
      })
      .then(async (res) => {
        console.log('🎯 [BUTTON] Pallet created, calling GET API like drag & drop');
        
        // 🚀 EXACT DRAG & DROP LOGIC: Set initial state from creation response
        dispatch(setPalletItems(res?.data?.products));
        dispatch(setPalletLoadedProgress(res?.data?.pallet_load_percents));
        setPalletId(`${res?.data?.id}`);
        dispatch(setIsLoaded(res?.data?.is_loaded));
        
        // 🚀 EXACT DRAG & DROP LOGIC: Make GET request like drag & drop does
        let _palletURL = `api/ERP/customer/mixedPallet/${res?.data?.id}`;
        if (defaultPostZip) {
          _palletURL += `?post_zip=${defaultPostZip}`;
        }

        await axios.get(_palletURL, {
          headers: { sessionId: getCookie("sessionid") },
        })
        .then(async (response) => {
          console.log('🎯 [BUTTON] GET pallet response like drag & drop');
          
          // 🚀 EXACT DRAG & DROP LOGIC: Update state with GET response
          dispatch(setPalletItems(response?.data?.products));
          dispatch(setPalletLoadedProgress(response?.data?.pallet_load_percents));
          dispatch(setIsLoaded(response?.data?.is_loaded));
          
          // 🚀 EXACT DRAG & DROP LOGIC: Set pallet name if needed
          if (!palletName) {
            await axios.post(`api/ERP/customer/mixedPallet/${res?.data?.id}/changeName`, {
              data: { name: `${vendorName} Mixed Pallet` },
              headers: { sessionId: getCookie("sessionid") },
            })
            .then((nameRes) => {
              dispatch(setPalletName(nameRes?.data?.name));
            })
            .catch((e) => {
              console.error('Name change error:', e);
            });
          }
          
          // 🚀 EXACT DRAG & DROP LOGIC: Show notification and turn off loading
          notification.success({
            message: getText().PDP.messages.productAddedToPallet,
            duration: 3,
          });
          dispatch(setLoading(false));
          
          // 🚀 EXACT DRAG & DROP LOGIC: Navigate to mixed pallet page
          router.query.pallet = res?.data?.id;
          router.push(router, undefined, { shallow: true });
        })
        .catch((e) => {
          console.error('GET pallet error:', e);
          dispatch(setLoading(false));
        });
      })
      .catch((e) => {
        console.error('Create pallet error:', e);
        dispatch(setLoading(false));
      });
    } else {
      // 🚀 EXACT DRAG & DROP LOGIC: Adding to existing pallet
      const payload = {
        data: { product: product?.id, case_quantity: null },
      } as AddItemToPalletPayload;
      setPalletProductQuantity({ palletId, payload, client });
    }
  }, [palletId, product?.id, defaultPostZip, vendorName, palletName]);

  const buildMixedPallet = useCallback(() => {
    const payload = {
      data: { product: product?.id, case_quantity: null },
      headers: { sessionId: getCookie("sessionid") },
    } as AddItemToPalletPayload;
    const params = defaultPostZip ? { post_zip: defaultPostZip } : {};
    buildMixedPalletApi({ payload, params, client });
  }, [product?.id]);

  const addToCartHandler = useCallback(
    (item: any, event: string) => {
      window?.dataLayer?.push({ ecommerce: null });
      window?.dataLayer?.push({
        event: event,
        ecommerce: {
          currency: "USD",
          value:
            !validGuestUser &&
            validCustomerStatus?.profile_completed &&
            validCustomerStatus?.email_verified &&
            ( item?.delivered_price),
          items: [
            {
              item_id:  item?.id?.toString(),
              item_name:  item?.name,
              coupon: "",
              currency: "USD",
              discount: 0,
              index: id,
              item_brand:  item?.brand_name || item?.brand?.name,
              item_category:item?.main_category  || item?.main_category_name,
              item_category2: item?.sub_category || item?.sub_category_name,
              item_list_id: "",
              item_list_name:
                titleOfList ||
               item?.sub_category || item?.sub_category_name,
              item_variant:item?.pack_size,
              price:
                !validGuestUser &&
                validCustomerStatus?.profile_completed &&
                validCustomerStatus?.email_verified &&
                 item?.delivered_price,
              quantity: 1,
            },
          ],
        },
      });
    },
    [product]
  );
  const addItemToCart = useCallback(
    (item: any) => {
      setAddToCartStatus(true);
      const payload = {
        data: {
          items: [
            {
              product: item?.slug,
              quantity: item?.sold_in_stack
                ? 2
                :  item?.min_pallet_quantity || 1,
            },
          ],
        },
        headers: { sessionId: getCookie("sessionid") },
      } as AddItemToCartPayload;
      setQuantityApi({ payload, client });
    },
    [product]
  );

  const viewDetailsHandler = useCallback(() => {
    dispatch(setProductListInfo({ id: id }));
    router.push(`/product/${product?.slug}`);
  }, [id]);

  const doWishlistAction = useCallback(
    (item: any) => {
      setShowToShoppingListDialog(true);
      setSelectedItem(item);
    },
    [product]
  );

  useEffect(() => {
    if (cart) {
      const cartPallets = cart?.pallets || [];
      cartPallets?.forEach((pallet: any) => {
        const palletItems = pallet?.pallet_items;
        palletItems?.forEach((cartItem: any) => {
          if (cartItem?.product?.id == (product?.id)) {
            setInCart(true);
          }
        });
      });
    }
  }, [cart]);

  const [itemHasPromo, setItemHasPromo] = useState(false);
  useEffect(() => {
    promoHandler(product, setItemHasPromo);
  }, []);

  const handleCompare = (sku: any) => {
    compareProductHandler(undefined, sku, isGuestUser!); 
  };

  return {
    setAddToCartStatus,
    addItemToCart,
    addItemToPallet,
    showModal,
    buildMixedPallet,
    setShowToShoppingListDialog,
    compareProductHandler,
    viewDetailsHandler,
    doWishlistAction,
    setFavClick,
    setIsWishlist,
    setIsModalOpen,
    addToCartHandler,
    addToCartStatus,
    router,
    validGuestUser,
    validCustomerStatus,
    inCart,
    favClick,
    isWishlist,
    isCustomerDataCompleted,
    setProductListInfo,
    palletId,
    vendorId,
    itemHasPromo,
    showShoppingListDialog,
    selectedItem,
    itemShoppingLists,
    isModalOpen,
    handleCompare, 
  };
};
